import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Typography,
} from "@material-tailwind/react";

import GaugeComponent from "react-gauge-component";
import { httpForPScreen } from "../../services/http-common";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { useEffect } from "react";

var CURRENT_TIME = new Date();

const ReportDetails = ({ screeningTestResult }) => {
  const { user } = useSelector((state) => state.auth);

  const mailReport = useMutation(
    () => {
      return httpForPScreen.post(
        `/psiloscreen/intakeform/send-email`,
        {
          username: user?.given_name,
          email: user?.email,
          age:
            CURRENT_TIME.getFullYear() -
            screeningTestResult?.prompts?.birthYear,
          currentMedication: screeningTestResult?.prompts?.currentMedication,
          pastAndCurrentMedicalConditions:
            screeningTestResult?.prompts?.pastAndCurrentMedicalConditions,
          knownAllergies: screeningTestResult?.prompts?.knownAllergies
            .map((allergy) => allergy.allergy)
            .join(", "),
          acuityScore: screeningTestResult?.acuityScore?.AcuityScore,
          acuityLevel: screeningTestResult?.acuityScore?.AcuityLevel,
          rationale: screeningTestResult?.acuityScore?.Rationale,
          recommendations: screeningTestResult?.acuityScore?.Recommendations,
        },
        null
      );
    },
    {
      onSuccess: ({ data }) => {
        toast.success(data.message);
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );
  const handleReport = () => {
    mailReport.mutate();
  };

  useEffect(() => {
    console.log("screeningTestResult", screeningTestResult);
  }, []);

  return (
    <>
      <div className={`agn-our-pricing py-5`}>
        <div className="container">
          <div className="theme-title-one text-center">
            <div className="upper-title">Screening Report</div>
            <h2 className="main-title">
              PsiloScreen Assessment Report
              {/* for {user.given_name} */}
            </h2>
          </div>
        </div>
        {screeningTestResult && (
          <>
            <div className="pricing-tab-menu mt-10">
              <table className="w-full min-w-max table-auto text-left">
                <thead>
                  <tr>
                    <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal leading-none opacity-70"
                      >
                        Field
                      </Typography>
                    </th>
                    <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal leading-none opacity-70"
                      >
                        Information
                      </Typography>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="p-4 border-b border-blue-gray-50">
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                      >
                        Acuity Score
                      </Typography>
                    </td>
                    <td className="p-4 border-b border-blue-gray-50">
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                      >
                        {screeningTestResult?.acuityScore?.AcuityScore}
                      </Typography>
                    </td>
                  </tr>
                  <tr>
                    <td className="p-4 border-b border-blue-gray-50">
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                      >
                        Acuity Level
                      </Typography>
                    </td>
                    <td className="p-4 border-b border-blue-gray-50">
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                      >
                        {screeningTestResult?.acuityScore?.AcuityLevel}
                      </Typography>
                    </td>
                  </tr>
                  {screeningTestResult?.prompts?.birthYear && (
                    <tr>
                      <td className="p-4 border-b border-blue-gray-50">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          Age
                        </Typography>
                      </td>
                      <td className="p-4 border-b border-blue-gray-50">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {CURRENT_TIME.getFullYear() -
                            screeningTestResult?.prompts?.birthYear}{" "}
                          years old
                        </Typography>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td className="p-4 border-b border-blue-gray-50">
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                      >
                        Current Medications
                      </Typography>
                    </td>
                    <td className="p-4 border-b border-blue-gray-50">
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                      >
                        {screeningTestResult?.prompts?.currentMedication}
                      </Typography>
                    </td>
                  </tr>
                  <tr>
                    <td className="p-4 border-b border-blue-gray-50">
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                      >
                        Past and Current Medical Conditions
                      </Typography>
                    </td>
                    <td className="p-4 border-b border-blue-gray-50">
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                      >
                        {
                          screeningTestResult?.prompts
                            ?.pastAndCurrentMedicalConditions
                        }
                      </Typography>
                    </td>
                  </tr>
                  <tr>
                    <td className="p-4 border-b border-blue-gray-50">
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                      >
                        Known Allergies
                      </Typography>
                    </td>
                    <td className="p-4 border-b border-blue-gray-50">
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                      >
                        {screeningTestResult?.prompts?.knownAllergies.map(
                          (allergy, idx) => (
                            <span key={idx}>
                              {allergy.allergy}
                              {idx + 1 ===
                              screeningTestResult?.prompts?.knownAllergies
                                .length
                                ? ""
                                : ", "}
                            </span>
                          )
                        )}
                      </Typography>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Card className="mt-6 ">
              <CardBody className="flex flex-col sm:flex-row justify-center items-center sm:gap-0 gap-5">
                <div className="sm:w-8/12 w-full flex flex-col justify-center items-start">
                  <Typography variant="h5" color="blue-gray" className="mb-2">
                    Rationale
                  </Typography>
                  <Typography>
                    {screeningTestResult?.acuityScore?.Rationale}
                  </Typography>
                </div>

                <div className="sm:w-4/12 w-full flex flex-col justify-center items-center">
                  <GaugeComponent
                    className="[&>svg]:w-auto"
                    style={{ width: "125%" }}
                    value={
                      parseInt(screeningTestResult?.acuityScore?.AcuityScore) ||
                      0
                    }
                    id="gauge-component4"
                    type="semicircle"
                    arc={{
                      gradient: true,
                      width: 0.53,
                      cornerRadius: 0,
                      padding: 0,
                      subArcs: [
                        { limit: 15, color: "#9fef33" },
                        { limit: 30, color: "#abec37" },
                        { limit: 60, color: "#fec145" },
                        { limit: 80, color: "#ff6639" },
                        { limit: 100, color: "#ff1e49" },
                      ],
                    }}
                    labels={{
                      valueLabel: {
                        style: {
                          marginTop: "10px !important",
                          fontSize: "30px !important",
                          textShadow: "none",
                          fontWeight: "bold",
                          background: "white",
                          fill: "#5a5a5a",
                        },
                      },
                      tickLabels: {
                        defaultTickValueConfig: {
                          style: {
                            fontSize: "1px",
                            fill: "#aeafaf",
                          },
                        },
                        ticks: [
                          {
                            value: 0,
                            valueConfig: {
                              formatTextValue: () => `Low`,
                            },
                            style: {
                              fontSize: "10px",
                              fill: "rgb(173 172 171)",
                            },
                          },
                          {
                            value: 25,
                            valueConfig: {
                              formatTextValue: () => `Moderate`,
                            },
                          },
                          {
                            value: 50,
                            valueConfig: {
                              formatTextValue: () => `Medium`,
                            },
                          },
                          {
                            value: 75,
                            valueConfig: {
                              formatTextValue: () => `High`,
                            },
                          },
                          {
                            value: 100,
                            valueConfig: {
                              formatTextValue: () => `Very High`,
                            },
                          },
                        ],
                      },
                    }}
                    pointer={{
                      type: "needle",
                      color: "#ffffff",
                      paddingBottom: "100px",
                      length: 0.8,
                      width: 10,
                    }}
                  />
                </div>
              </CardBody>
            </Card>

            <Card className="mt-6 ">
              <CardBody>
                <Typography variant="h5" color="blue-gray" className="mb-2">
                  Recommendations
                </Typography>
                <Typography>
                  {screeningTestResult?.acuityScore?.Recommendations}
                </Typography>
              </CardBody>
              <CardFooter className="pt-0">
                <Button onClick={() => handleReport()}>Email Report</Button>
              </CardFooter>
            </Card>
          </>
        )}
      </div>
    </>
  );
};

export default ReportDetails;
